import { RootState } from '../../store'
import { regionsAdapter } from './slice'

export const entityAdapterSelectors = regionsAdapter.getSelectors<RootState>(
  (state) => state.regions
)

export const { selectAll: selectAllRegions, selectById: selectRegionById } =
  entityAdapterSelectors

export const selectSelectedRegion = (state: RootState) =>
  state.regions.selectedId
    ? selectRegionById(state, state.regions.selectedId)
    : undefined
